Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isReactNative = isReactNative;
/* eslint-disable import/prefer-default-export */
function isReactNative() {
  return global.navigator && global.navigator.product === 'ReactNative';
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-with-tracking/build/utils/productUtils.js
// module id = 482
// module chunks = 168707334958949